export enum ConnectionTypeEnum {
  'MANUAL' = 'MANUAL',
  'BANK' = 'BANK',
  'WALLET' = 'WALLET',
}
